import $ from 'jquery';

// header menu
$(document).ready(function () {
	const $menu = $('.menu_theme_header');

	$(window).load(function () {
		const $categories = $menu.children('.menu__categories');
		const scrollBarHeight = $categories[0].offsetHeight - $categories[0].clientHeight;
		if (scrollBarHeight) {
			const $wrapper = $('<div class="menu__wrapper"></div>');
			$wrapper.append($categories);
			$menu.prepend($wrapper);
			// $categories.wrap($wrapper);
			$wrapper.height($categories[0].clientHeight);
			$(window).resize(function () {
				$wrapper.height($categories[0].clientHeight);
			});
		}
	});


	if ($menu.is('.menu_theme_header.menu_expanded')){
		const $subcategoryList = $('<ul class="menu__subcategory-list"></ul>');
		const $categoryList = $menu.find('.menu__category');
		$categoryList.each(function () {
			const $item = $('<li class="menu__subcategory-item"></li>');
			$item.append($(this).find('.menu__subcategories'));
			if ($(this).is('.menu__category_active')) {
				$item.addClass('menu__subcategory-item_active');
			}
			$subcategoryList.append($item);
		});
		$menu.append($subcategoryList);
		$subcategoryList.css({height: $('.menu__subcategory-item_active')[0].offsetHeight});
		$menu.find('.menu__category').mouseenter(function (){
			const $subcategoryItem = $menu.find('.menu__subcategory-item').eq($(this).index());
			if (!$subcategoryItem.is(':empty')) {
				$subcategoryItem
					.addClass('menu__subcategory-item_active')
					.siblings()
					.removeClass('menu__subcategory-item_active');
				$subcategoryList.css({height: $subcategoryItem[0].offsetHeight});
			}
		});
		$menu.mouseleave(() => {
			const $category = $menu.find('.menu__category_active');
			const $subcategoryItem = $menu.find('.menu__subcategory-item').eq($category.index());
			$subcategoryItem
				.addClass('menu__subcategory-item_active')
				.siblings()
				.removeClass('menu__subcategory-item_active');
			$subcategoryList.css({height: $subcategoryItem[0].offsetHeight});
		});
	}
});


$(window).load(function (){
	const $menu = $('.menu_theme_footer');

	if ($(window).innerWidth() < 800){
		$menu
			.addClass('menu_theme_accordion')
			.removeClass('menu_theme_footer');
		const $captions = $menu.find('.menu__category-caption');
		$captions.click(function () {
			if (!$(this).closest('.menu__category').hasClass('menu__category_active')){
				$(this)
					.closest('.menu__category')
					.addClass('menu__category_active');
				$captions
					.not(this)
					.closest('.menu__category')
					.removeClass('menu__category_active');
			}else {
				$(this)
					.closest('.menu__category')
					.removeClass('menu__category_active');
			}
		});
	}
	$(window).resize(function (){
		if ($(window).innerWidth() < 700){
			$menu
				.addClass('menu_theme_accordion')
				.removeClass('menu_theme_footer');
		}
		if ($(window).innerWidth() >= 700 && $menu.hasClass('menu_theme_accordion')) {
			$menu
				.addClass('menu_theme_footer')
				.removeClass('menu_theme_accordion');
		}
	});
});



/** WEBPACK FOOTER **
 ** ./app/blocks/menu/menu.js
 **/